export enum SecurityType {
  CS = 'cs',
  REIT = 'reit',
  IFF = 'iff',
  ETF = 'etf',
  CS_FOREIGN = 'cs_foreign',
}
